import { makeAutoObservable } from 'mobx';
import { FirebaseApp, initializeApp } from 'firebase/app';
import { firebaseConfig } from '../configs/firebase.config';
import {
  Auth,
  connectAuthEmulator,
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
} from 'firebase/auth';
import { FirebaseAuthPort, FirebaseDBPort, FirebaseStoragePort, UseFirebaseEmulator } from '../utils/appConfig';
import {
  getStorage,
  FirebaseStorage,
  connectStorageEmulator,
} from 'firebase/storage'
import { Firestore, connectFirestoreEmulator, initializeFirestore } from 'firebase/firestore'

class FirebaseStore {
  firebaseApp: FirebaseApp;
  authService: Auth;
  storageService: FirebaseStorage;
  dbService: Firestore;

  constructor() {
    makeAutoObservable(this);
    this.firebaseApp = initializeApp(firebaseConfig);
    this.authService = getAuth(this.firebaseApp);
    this.dbService = initializeFirestore(this.firebaseApp, { ignoreUndefinedProperties: true });
    this.storageService = getStorage(this.firebaseApp);

    this.connectToEmulator();
  }

  connectToEmulator() {
    if (UseFirebaseEmulator) {
      connectAuthEmulator(this.authService, `http://127.0.0.1:${FirebaseAuthPort}`);
      connectFirestoreEmulator(this.dbService, '127.0.0.1', FirebaseDBPort);
      connectStorageEmulator(this.storageService, '127.0.0.1', FirebaseStoragePort)
    }
  }

  signInWithEmailAndPassword = (email: string, password: string) =>
    signInWithEmailAndPassword(this.authService, email, password);

  signOut = () => this.authService.signOut();

  onAuthUserListener = (next: any, fallback: any) =>
    onAuthStateChanged(this.authService, (authUser) => {
      if (authUser) {
        const email = authUser?.email ?? ''
        const u = {
          uid: authUser?.uid ?? '',
          email,
          emailVerified: authUser?.emailVerified ?? false,
          providerData: authUser?.providerData ?? [],
        };
        next(u)
      } else {
        fallback();
      }
    });
}

export default FirebaseStore;